import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  public accountForm: FormGroup;
  public permissionForm: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  constructor(private ActivatedRoute: ActivatedRoute, private formBuilder: FormBuilder,  private http: HttpClient, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {}

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      this.http.get<any>(`${environment.apiUrl}/adminById/${id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
        data => {
          (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
          if(data.data != null){
            this.action = 'Update';
            this.accountForm.patchValue({
              _id: data.data._id,
              name: data.data.name,
              contact: data.data.contact,
              email: data.data.email,
              role: data.data.role,
              active: data.data.active,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

  this.accountForm = this.formBuilder.group({
      name: ['', Validators.required],
      contact: ['', Validators.required],
      role: ['', Validators.required],
      active: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      _id: ['', ],
    });
  }

  get f() { return this.accountForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.accountForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    var data = {
      "name" : this.accountForm.value.name,
      "contact" : this.accountForm.value.contact,
      "role" : this.accountForm.value.role,
      "email" : this.accountForm.value.email,
      "active" : this.accountForm.value.active,
      "admin" : localStorage.getItem('adminName'),
    };
    this.http.post<any>(`${environment.apiUrl}/admin/`, data, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.Error){
          this.message = res.message;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
          this.router.navigateByUrl('/users/list');
        } 
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "name" : this.accountForm.value.name,
      "contact" : this.accountForm.value.contact,
      "role" : this.accountForm.value.role,
      "email" : this.accountForm.value.email,
      "active" : this.accountForm.value.active,
      "admin" : localStorage.getItem('adminName'),
      "_id" : this.accountForm.value._id,
    };
      this.http.put<any>(`${environment.apiUrl}/admin/`, data1, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        (res.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
        if(res.status == '500'){
          this.message = res.message;
          this.class = 'btn-primary rounded px-1 py-1';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return 0;
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn-success rounded px-1 py-1';
          this.router.navigateByUrl('/users/list');
        } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }
  

}
